<template>
  <div>
    <div
      :style="{ opacity }"
      ref="animatedBg"
      class="animated-background"
    ></div>
    <Birds :minHeight="heroMinHeight" />
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'Mrinalini',

    metaInfo: {
      title: 'Mrinalini'
    }
  }
</script>

<script>
  import Birds from '@/components/Birds'
  import Navbar from '@/components/Navbar'

  import { mapActions } from 'vuex'

  export default {
    name: 'Mrinalini',

    metaInfo: {
      title: 'Mrinalini'
    },

    data() {
      return {
        heroMinHeight: screen.height
      }
    },
    components: {
      Navbar,
      Birds
    },

    methods: {
      ...mapActions(['getWindowSize']),
      handleResize() {
        const root = document.getElementsByTagName('html')[0]
        const windowSize = {
          width: root.clientWidth,
          height: root.clientHeight
        }
        this.getWindowSize(windowSize)
      }
    },

    computed: {
      opacity() {
        return this.$store.state.scrollPos
      }
    },

    mounted() {
      window.addEventListener('resize', this.handleResize)
      this.handleResize()
    },

    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize)
    }
  }
</script>

<style scoped lang="scss">
  .animated-background {
    background-color: $travel-bg;
  }
</style>
